import { Skeleton } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";

import { DiscoveryContext } from "../discovery-context";
import ErrorMessage from "./../../../Component/ErrorMessage/ErrorMessage";
import classes from "./Description.module.css";

export default function Description({ entity, category, llm}) {
  const abortControllerRef = useRef(null);
  const [error, setError] = useState();

  const discoveryCtx = useContext(DiscoveryContext);
  

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  useEffect(() => {
    if (discoveryCtx?.brand_description[llm][category]?.length > 0) return;

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [entity, discoveryCtx?.brand_description[llm][category]]);

  let brandDescription = null;
  let loading = true;
  if (discoveryCtx?.brand_description[llm][category]?.length > 0) {
    brandDescription = discoveryCtx?.brand_description[llm][category]
    loading = false;
  }

  return (
    <div className={classes.text}>
      {loading && !error && (
        <>
          <Skeleton />
          <Skeleton style={{ width: "50%" }} />
        </>
      )}
      {!error && !loading && brandDescription}
      {error && (
        <ErrorMessage
          message={error}
          retry
          align="left"
          // onRetry={() => getBrandDescription()}
        />
      )}
    </div>
  );
}
